import { Link } from 'react-router-dom';
import { Comic, latestComics } from '@/mocks/comics';

function LatestCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group flex gap-4 p-4 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
    >
      <div className="w-20 h-28 md:w-24 md:h-32 flex-shrink-0 rounded-lg overflow-hidden">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
      </div>
      <div className="flex-1 min-w-0 flex flex-col justify-between">
        <div>
          <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
            {comic.title}
          </h3>
          <p className="text-xs text-foreground-500 mt-1 line-clamp-2">
            {comic.description}
          </p>
        </div>
        <div className="flex items-center gap-3 text-xs text-foreground-400 mt-2">
          <span>{comic.author}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span className="text-primary-500">{comic.category}</span>
          <span className="w-1 h-1 rounded-full bg-foreground-300"></span>
          <span>更新至{comic.chapters}话</span>
        </div>
      </div>
    </Link>
  );
}

export default function LatestUpdates() {
  return (
    <section className="bg-background-100/50 py-10 md:py-14">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">新鲜出炉的热门漫画</p>
          </div>
          <Link to="/category/romance" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
            全部作品 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {latestComics.map((comic) => (
            <LatestCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}